export default __webpack_public_path__ + "static/iconjar2-8-1-f81916f501a647269f01cb598227c8ed.mp4";